import { Injectable } from "@angular/core";

@Injectable()
export class EslIdAuthService {
    protected getCacheKey(id: number): string {
        return `eslid:auth-token:${id}`;
    }

    public getAuthToken(id: number): string {
        return localStorage.getItem(this.getCacheKey(id));
    }

    public setAuthToken(id: number, token: string): void {
        localStorage.setItem(`${this.getCacheKey(id)}`, token);
    }
}
